var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_172475",
    "data-name": "\\uADF8\\uB8F9 172475",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.929,
    height: 46.067,
    viewBox: "0 0 43.929 46.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121635",
    "data-name": "\\uD328\\uC2A4 121635",
    d: "M3207.844,1171.548s-15.227,13.183-21.561,16.049c9.966,23.56,25.208,27.03,25.208,27.03s8.814-8.191,18.721-19.691C3211.207,1188.23,3207.844,1171.548,3207.844,1171.548Z",
    transform: "translate(-3186.283 -1168.561)",
    fill: "#6b6b6b",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121636",
    "data-name": "\\uD328\\uC2A4 121636",
    d: "M3207.844,1149.571s-15.227,13.183-21.561,16.05c9.966,23.56,25.208,27.03,25.208,27.03s8.814-8.191,18.721-19.691C3211.207,1166.253,3207.844,1149.571,3207.844,1149.571Z",
    transform: "translate(-3186.283 -1149.571)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121637",
    "data-name": "\\uD328\\uC2A4 121637",
    d: "M3238.8,1202.586a37.621,37.621,0,0,0-3.823,2.762c-1.262.961-2.528,1.918-3.783,2.888q-3.805,2.941-7.591,5.906c-.366.287.133.8.5.521q3.78-2.889,7.539-5.805c1.252-.971,2.5-1.953,3.74-2.933a37.888,37.888,0,0,0,3.653-3.025A.2.2,0,0,0,3238.8,1202.586Z",
    transform: "translate(-3218.421 -1195.356)",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121638",
    "data-name": "\\uD328\\uC2A4 121638",
    d: "M3258.76,1226.558a10.349,10.349,0,0,0-1.779,1.318c-.615.5-1.217,1.007-1.825,1.512-1.187.988-2.377,1.971-3.56,2.963-2.391,2.007-4.793,4-7.157,6.043-.349.3.139.8.488.513,2.412-1.982,4.79-4.01,7.174-6.024,1.179-1,2.35-2,3.524-3,.6-.512,1.206-1.018,1.8-1.539a10.236,10.236,0,0,0,1.585-1.522C3259.13,1226.66,3258.916,1226.48,3258.76,1226.558Z",
    transform: "translate(-3236.43 -1216.076)",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121639",
    "data-name": "\\uD328\\uC2A4 121639",
    d: "M3275.581,1251.894a9.5,9.5,0,0,0-1.883,1.373c-.583.483-1.156.977-1.731,1.469q-1.808,1.545-3.608,3.1-3.6,3.106-7.2,6.218c-.364.316.151.849.513.539q3.612-3.093,7.211-6.2,1.8-1.551,3.6-3.112c.6-.52,1.2-1.038,1.788-1.566a8.953,8.953,0,0,0,1.538-1.579C3275.91,1251.984,3275.725,1251.825,3275.581,1251.894Z",
    transform: "translate(-3250.876 -1237.97)",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121640",
    "data-name": "\\uD328\\uC2A4 121640",
    d: "M3301.629,1269.865a24.181,24.181,0,0,0-3.64,3.429q-1.738,1.778-3.459,3.571L3291,1280.52q-.863.894-1.726,1.789-.45.467-.9.938a2.559,2.559,0,0,0-.359.388c-.077.13-.048.287-.118.423a.159.159,0,0,0,.211.221c.149-.082.3-.068.442-.152a1.963,1.963,0,0,0,.34-.338q.453-.465.9-.93.9-.933,1.8-1.868l3.45-3.581q1.762-1.83,3.518-3.667a23.71,23.71,0,0,0,3.236-3.7C3301.867,1269.941,3301.741,1269.79,3301.629,1269.865Z",
    transform: "translate(-3274.072 -1253.495)",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121641",
    "data-name": "\\uD328\\uC2A4 121641",
    d: "M3328.072,1302.9a26.227,26.227,0,0,0-3.293,3.165q-1.584,1.614-3.167,3.228c-2.156,2.206-4.368,4.37-6.47,6.626-.289.31.149.78.457.48,2.207-2.154,4.319-4.415,6.474-6.622q1.618-1.657,3.229-3.319a25.506,25.506,0,0,0,3.023-3.295C3328.424,1303.012,3328.228,1302.787,3328.072,1302.9Z",
    transform: "translate(-3297.542 -1282.029)",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121642",
    "data-name": "\\uD328\\uC2A4 121642",
    d: "M3359.627,1330.016a8.069,8.069,0,0,0-1.669,1.445c-.544.531-1.074,1.077-1.609,1.617-1.045,1.055-2.076,2.125-3.113,3.187q-3.187,3.267-6.365,6.543c-.332.341.178.877.51.536q3.178-3.277,6.352-6.557c1.057-1.094,2.122-2.182,3.169-3.285.524-.552,1.055-1.1,1.569-1.66a7.877,7.877,0,0,0,1.334-1.64A.134.134,0,0,0,3359.627,1330.016Z",
    transform: "translate(-3324.947 -1305.472)",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment6);
export default __webpack_public_path__ + "static/media/recruitment6.b9066cc4b000faebca20c0aedf8cd9bb.svg";
export { ForwardRef as ReactComponent };